import cn from 'classnames';
import type { ReactNode } from 'react';
import styles from './scrollable-content-header.module.css';

export type ScrollableContentHeaderProperties = {
  children?: ReactNode;
  className?: string;
};

const ScrollableContentHeader = ({ children, className }: ScrollableContentHeaderProperties) => (
  <div className={cn(className, styles.header)}>{children}</div>
);

export default ScrollableContentHeader;
